document.querySelectorAll('.product__image-wrapper').forEach(item => {
    item.addEventListener('touchstart', function() {
      this.querySelector('.primary-image').style.display = 'none';
      this.querySelector('.secondary-image').style.display = 'block';
    });

    item.addEventListener('touchend', function() {
      this.querySelector('.primary-image').style.display = 'block';
      this.querySelector('.secondary-image').style.display = 'none';
    });
  });

